(function ($) {
    
    function init__foyer() {
        const section = $('.foyer');

        section.each(function(){
            const 
                $this = $(this),
                videoIn = $this.find('.foyer__fly'),
                videoLoop = $this.find('.foyer__loop'),
                title = $this.find('.foyer__title'),
                grid = $this.find('.foyer__grid'),
                sessions = $this.find('.foyer__sessions'),
                tl = gsap.timeline({paused: true});

            gsap.set(title, {opacity: 0, x: -100});
            gsap.set(sessions, {opacity: 0, x: 100});

            tl.to($this, {opacity: 1, visibility: 'visible'})
            tl.add( anim__video(videoIn) );
            tl.add( function(){ Cookies.set('foyer_visited', ''); } );
            tl.addLabel('Fly Complete');
            tl.add( anim__video(videoLoop) );
            tl.to([title,sessions], { opacity: 1, x:0, stagger: 0.3 });
            tl.add( anim__cards(grid).duration(3.5), '=-0.3');
            tl.addLabel('End');

            if (window.innerWidth > 994 && Cookies.get('foyer_visited') == undefined) {
                tl.tweenTo('Fly Complete');
                videoIn.on('ended', function(){ tl.play() });
            } else {
                tl.tweenFromTo('Fly Complete', 'End')
            }

            

            function anim__video(ele) {
                let tl = gsap.timeline();

                gsap.set(ele, {opacity: 0});

                tl.to( ele, {opacity: 1});
                tl.add( function() { 
                    if (ele[0].localName == 'video') ele[0].play();
                });
                return tl;
            }

            function anim__cards(ele) {
                let tl = gsap.timeline({
                    onStart: function() {
                        card.addClass('animating');
                    },
                    onComplete: function() {
                        inner.attr('style', '');
                    //     card.removeClass('animating');
                    //     card.addClass('animated');
                    //     inner.attr('style', '');
                    }
                }),
                    item = ele.find('.foyer__grid-item'),
                    card = ele.find('.card'),
                    inner = ele.find('.card__inner');

                // set stuff
                gsap.set(ele, {opacity: 0});
 
                item.each(function(i) {
                    gsap.set(card[i], postionToCenter($(this)))
                });
                gsap.set(inner, {rotateX: 90})
                gsap.set(inner, {rotateY: -180})
                gsap.set(card, { scale: 0.1})
                
                tl.to(ele, {opacity: 1});
                item.each(function(i) {
                    let delay = gsap.utils.random(0, 0.7, 0.1);

                    tl.to(card[i], 1, {delay: delay, scale: 1}, 0);
                    tl.to(inner[i], 1, {delay: delay, rotateX: 0}, 0);
                    tl.to(inner[i], 1, {delay: delay, rotateY: 0}, 0);
                    // add addtional up to bottom row
                    tl.to(card[i], 1, {delay: delay, y :0, ease: (i < 4 ? 'back.out(1.5)' : 'back.out(6)')}, 0);

                    tl.to(card[i], 1, {delay: delay, x: 0, }, 0);
                    tl.to(inner[i], 0.5, {delay: delay, rotateZ: -10}, 0);
                    tl.to(inner[i], 0.5, {delay: delay, rotateZ: 0}, 0.5);
                    tl.set(inner[i], {delay: delay, rotateY: 0});
                    tl.add( function() {
                        $(card[i]).removeClass('animating');
                        $(card[i]).addClass('animated');
                    }, '-=0.3')
                });

                return tl;
            }

            function postionToCenter($ele) {
                const obj = {}; 
                obj.x = window.innerWidth/2 - ($ele.offset().left + $ele.width()/2);
                obj.y = window.innerHeight/2 - ($ele.offset().top + $ele.height()/2) - (5/100 * window.innerHeight);
                return obj;
            }
        });
    }

    $(window).on('load', function() {
        init__foyer();
    });
    
    // run function after barba enter
    if(window.barba !== undefined) {
        barba.hooks.enter((data) => {
            setTimeout(function() {
                init__foyer();
            }, 500);
        });
    }
})(jQuery);